<app-summary-field [label]="label">
    <app-datetime-label [date]="datetime"></app-datetime-label>
</app-summary-field>
